import React from 'react';

export default ({ isVisible, title, description }) => {
  if (!isVisible) {
    return null;
  }
  return (
    <div className="galleria-info">
      <div className="galleria-info-text">
        {
          title &&
          <div
            className="galleria-info-title"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        }
        {
          description &&
          <div
            className="galleria-info-description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        }
      </div>
      <div className="galleria-info-close"></div>
    </div>
  );
};
